module.exports = __webpack_public_path__ + "img/advantage_006.6a17f845.png";